import { HttpFilter } from "sol-request-angular/dist/comunicacao";
import { FilterEqual } from "sol-request-angular/dist/comunicacao/filter/FilterEqual";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { AutoCompleteConfig } from "../config/autocomplete.config";

export class AutocompleteSearch {

    constructor(public config: AutoCompleteConfig) {}

    get(primaryKey: number) {
        try {           
            if(!this.config.service) throw new Error('O serviço do autocomplete não foi definido.');

            return this.config.service.get(primaryKey)
                       .catch(error => console.error(error));
        } catch (error) {
            console.error(error);
        }
    }

    find(keyword: string): Promise<any> {
        try {           
            if(!this.config.service) throw new Error('O serviço do autocomplete não foi definido.');

            const criteria = this.buildCriteria(keyword);

            return this.config.service.find(criteria)
                       .then(results => results instanceof Array ? results : results.items)
                       .catch(error => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    private buildCriteria(keyword: string): GenericSearch {
        const searchCriteria = { [this.config.keyword]: keyword };

        if (this.config.additionalCriteria) {
            Object.assign(searchCriteria, this.config.additionalCriteria);
        }

        return new GenericSearch(searchCriteria);
    }
}

class GenericSearch {
    props;

    constructor(props: any) {
        this.props = props;
    }

    getFilters() {
        let filters: IFilter = new HttpFilter([]);

        Object.keys(this.props).forEach((key) => filters.addFilter(new FilterEqual(key, this.props[key])));

        return filters;
    }
}